import actions from './actions';

const {FETCH_SHIFT_EMPLOYEES, RESET_FETCH_SHIFT_EMPLOYEE} = actions;
const initState = {
    shiftEmployees: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
};

const UserShiftEmployeesReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_SHIFT_EMPLOYEES:
            return {
                ...state,
                shiftEmployees: data,
            };
        case RESET_FETCH_SHIFT_EMPLOYEE:
            return {
                ...state,
                shiftEmployees: initState.shiftEmployees
            };
        default:
            return state;
    }
};

export default UserShiftEmployeesReducer;
